import * as React from "react";
import styled from "styled-components";
import { RadioInputProps } from "./RadioGroup";

export const Label = styled("label")`
    input:checked + & {
        border: 2px solid ${(props) => props.theme.palette.primary.main};
        font-weight: 700;
    }
`;

const RadioInput: React.FunctionComponent<RadioInputProps> = ({
    name,
    label,
    id,
    value,
    isDefault,
    reportUp,
}: RadioInputProps) => {
    const handleChange = () => {
        if (typeof reportUp === "function") {
            reportUp(id, value);
        }
    };
    return (
        <li className="OSRadioGroup__item">
            <input
                className="OSRadioGroup__input"
                id={id}
                name={name}
                type="radio"
                value={value}
                onChange={handleChange}
                defaultChecked={isDefault}
            />
            <Label className="OSRadioGroup__label" htmlFor={id}>
                {label}
            </Label>
        </li>
    );
};

RadioInput.defaultProps = {
    isDefault: false,
    reportUp: () => {
        // noop
    },
};

export default RadioInput;
